import React from 'react'

function Clock({ size }: { size?: number }) {
  return (
    <svg width={size || 24} height={size || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2081_61050)">
        <path
          d="M21.4746 6.31494C20.9775 6.55542 20.7695 7.15356 21.01 7.65039C21.667 9.00757 22 10.4705 22 12C22 17.5139 17.5139 22 12 22C6.48608 22 2 17.5139 2 12C2 6.48608 6.48608 2 12 2C14.2849 2 16.4314 2.74609 18.208 4.15747C18.6389 4.50146 19.269 4.42944 19.613 3.99707C19.957 3.56494 19.885 2.93555 19.4524 2.59204C17.3491 0.92041 14.7024 0 12 0C5.38354 0 0 5.38354 0 12C0 18.6165 5.38354 24 12 24C18.6165 24 24 18.6165 24 12C24 10.1665 23.5996 8.40942 22.8101 6.77954C22.5701 6.28149 21.97 6.07397 21.4746 6.31494Z"
          fill="#27A27E"
        />
        <path
          d="M12 4C11.448 4 11 4.448 11 5V12C11 12.552 11.448 13 12 13H17C17.552 13 18 12.552 18 12C18 11.448 17.552 11 17 11H13V5C13 4.448 12.552 4 12 4Z"
          fill="#98E5CE"
        />
      </g>
      <defs>
        <clipPath id="clip0_2081_61050">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Clock
